export enum TouchState {
    Start = 0,
    Move = 1,
    End = 2,
    Cancel = 3
}
